// extracted by mini-css-extract-plugin
export default {"root":"simple-mixing-custom-bag-modal_root__xNnQU","content":"simple-mixing-custom-bag-modal_content__NYbMh"};